import { useConnection } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../../context";

export const usePlanAvailableDiscountIDs = () => {
	const { viewModel, onSetViewModel, queryData } = useProductDayTripPlanFormModelContext();
	const { availableDiscountIDs } = viewModel;
	const { discountNameAndIDOptions } = queryData.connection;

	return useConnection<"availableDiscountIDs">({
		availableItemIDs: availableDiscountIDs, //
		nameAndIDOptions: discountNameAndIDOptions,
		keyOfValue: "availableDiscountIDs",
		onSetViewModel,
	});
};
